// Tenant configuration the registration form reads: the sex and relationship value sets,
// the consent wording, and which fields are required (plan §12, decisions 3, 8, 9, 10).
// Value sets and consent texts need patients.register; settings need patients.read.
import {
  consentTextSchema,
  registrationSettingsSchema,
  valueSetConceptSchema,
  type ValueSet,
} from '@wodi/shared';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';

import { api } from './client.ts';

export const valueSetQuery = (valueSet: ValueSet) =>
  queryOptions({
    queryKey: ['value-sets', valueSet],
    queryFn: () =>
      api('GET', `/value-sets/${valueSet}`, { schema: z.array(valueSetConceptSchema) }),
    staleTime: 5 * 60_000,
  });

export const consentTextsQuery = queryOptions({
  queryKey: ['consent-texts'],
  queryFn: () => api('GET', '/consent-texts', { schema: z.array(consentTextSchema) }),
  staleTime: 5 * 60_000,
});

export const registrationSettingsQuery = queryOptions({
  queryKey: ['registration-settings'],
  queryFn: () => api('GET', '/registration-settings', { schema: registrationSettingsSchema }),
  staleTime: 5 * 60_000,
});
